import AddCircleIcon from './AddCircleIcon';
import CheckIcon from './CheckIcon';
import CircleCheckIcon from './CircleCheckIcon';
import CircleIcon from './CircleIcon';
import CreditCard from './CreditCard';
import QuestionCircleIcon from './QuestionCircleIcon';
import SolidPersonIcon from './SolidPersonIcon';
import SolidTrashIcon from './SolidTrashIcon';

export {
  AddCircleIcon,
  CheckIcon,
  CircleCheckIcon,
  CircleIcon,
  CreditCard,
  QuestionCircleIcon,
  SolidPersonIcon,
  SolidTrashIcon,
};
